module.exports = __webpack_public_path__ + "static/media/Assignedtraining-icon.36df646a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/assets/images/Assignedtraining-icon.svg
// module id = 1845
// module chunks = 27